// Actions
const CLEAR_MODAL_FORM = 'zen/storyAndSourceChecker/CLEAR_MODAL_FORM';
const EDIT_SOURCES_OR_STORIES_LIST = 'zen/storyAndSourceChecker/EDIT_SOURCES_OR_STORIES_LIST';
const FETCH_SOURCE_CHECKER_RESULTS = 'zen/storyAndSourceChecker/FETCH_SOURCE_CHECKER_RESULTS';
const FETCH_SOURCE_CHECKER_RESULTS_FAILED = 'zen/storyAndSourceChecker/FETCH_SOURCE_CHECKER_RESULTS_FAILED';
const FETCH_SOURCE_CHECKER_RESULTS_SUCCEEDED = 'zen/storyAndSourceChecker/FETCH_SOURCE_CHECKER_RESULTS_SUCCEEDED';
const FETCH_STORY_CHECKER_RESULTS = 'zen/storyAndSourceChecker/FETCH_STORY_CHECKER_RESULTS';
const FETCH_STORY_CHECKER_RESULTS_FAILED = 'zen/storyAndSourceChecker/FETCH_STORY_CHECKER_RESULTS_FAILED';
const FETCH_STORY_CHECKER_RESULTS_SUCCEEDED = 'zen/storyAndSourceChecker/FETCH_STORY_CHECKER_RESULTS_SUCCEEDED';
const FETCH_STORY_CHECKER_DETAIL = 'zen/storyAndSourceChecker/FETCH_STORY_CHECKER_DETAIL';
const FETCH_STORY_CHECKER_DETAIL_FAILED = 'zen/storyAndSourceChecker/FETCH_STORY_CHECKER_DETAIL_FAILED';
const FETCH_STORY_CHECKER_DETAIL_SUCCEEDED = 'zen/storyAndSourceChecker/FETCH_STORY_CHECKER_DETAIL_SUCCEEDED';
const FETCH_SOURCE_CHECKER_SIMILARS = 'zen/storyAndSourceChecker/FETCH_SOURCE_CHECKER_SIMILARS';
const FETCH_SOURCE_CHECKER_SIMILARS_FAILED = 'zen/storyAndSourceChecker/FETCH_SOURCE_CHECKER_SIMILARS_FAILED';
const FETCH_SOURCE_CHECKER_SIMILARS_SUCCEEDED = 'zen/storyAndSourceChecker/FETCH_SOURCE_CHECKER_SIMILARS_SUCCEEDED';
const STORY_PROFILE_SELECTION = 'zen/storyAndSourceChecker/STORY_PROFILE_SELECTION';
const STORY_SOURCE_SELECTION = 'zen/storyAndSourceChecker/STORY_SOURCE_SELECTION';
const SET_CHECK_BY = 'zen/storyAndSourceChecker/SET_CHECK_BY';
const SET_SOURCE_TYPE = 'zen/storyAndSourceChecker/SET_SOURCE_TYPE';
const SET_IS_MODAL_FORM_STEP = 'zen/storyAndSourceChecker/SET_IS_MODAL_FORM_STEP';
const TOGGLE_MODAL = 'zen/storyAndSourceChecker/TOGGLE_MODAL';
const TOGGLE_FILTER = 'zen/storyAndSourceChecker/TOGGLE_FILTER';
const HIDE_SIMILAR_SOURCES = 'zen/storyAndSourceChecker/HIDE_SIMILAR_SOURCES';
const EDIT_TITLE = 'zen/storyAndSourceChecker/EDIT_TITLE';
const TOGGLE_INCLUDE_ALL = 'zen/storyAndSourceChecker/TOGGLE_INCLUDE_ALL';

const initFiltersValues = {
  covered: true,
  notCovered: true,
  invalid: true,
};

const MODAL_STAGES = {
  search: 'search',
  results: 'results',
  resultDetail: 'resultDetail'
};

const SOURCE_OPTIONS_URLS = [
  {value: 'news', label: 'News'},
  {value: 'blogs', label: 'Blogs'},
];

const SOURCE_OPTIONS_CONTENT = [
  ...SOURCE_OPTIONS_URLS,
  {value: 'lexis_nexis', label: 'LexisNexis'},
];

const initialState = {
  isModalOpen: false,
  isFetching: false,
  modalStage: MODAL_STAGES.search,
  sourceCheckerResults: [],
  storyCheckerResults: [],
  storyCheckerDetail: {},
  sourcesOrStoriesToCheck: '',
  selectedCheckByOption: 'sources',
  // NOTE: "SourceType" is the 'type of Source being checked' vs. a Source Type like 'twitter', 'blogs', etc.
  selectedSourceOrStoryType: undefined,
  filters: Object.assign({}, initFiltersValues),
  sourceCheckerSimilars: new Map(),
  showSourceCheckerSimilars: {},
  fetchingSimilarFor: null,
  selectedProfiles: [],
  // In contrast to 'selectedSourceOrStoryType' this IS "a Source Type like 'twitter', 'blogs', etc."
  // TODO: Rename selectedSourceOrStoryType now that we have real source types in here. Suggest: selectedContentType
  // and rename the 'content' value to 'text' so you have 'urls' and 'text'.
  selectedSource: 'news',
  title: '',
  includeAll: false
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = Object.assign({}, initialState), action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case CLEAR_MODAL_FORM:
      state.sourceCheckerSimilars.clear();
      state.filters = Object.assign({}, initFiltersValues);
      return initialState;
    case EDIT_SOURCES_OR_STORIES_LIST:
      return {...state, sourcesOrStoriesToCheck: payload};

    case FETCH_SOURCE_CHECKER_RESULTS:
      state.sourceCheckerSimilars.clear();
      return {...state, isFetching: true, sourceCheckerResults: [], modalStage: MODAL_STAGES.results,
        filters: Object.assign({}, initFiltersValues),
        showSourceCheckerSimilars: {},
      };
    case FETCH_SOURCE_CHECKER_RESULTS_SUCCEEDED:
      return {...state, isFetching: false, sourceCheckerResults: payload};
    case FETCH_SOURCE_CHECKER_RESULTS_FAILED:
      return {...state, isFetching: false, sourceCheckerResults: []};

    case FETCH_STORY_CHECKER_RESULTS:
      state.sourceCheckerSimilars.clear();
      return {...state, isFetching: true, storyCheckerResults: [], modalStage: MODAL_STAGES.results,
        filters: Object.assign({}, initFiltersValues),
        showSourceCheckerSimilars: {},
      };
    case FETCH_STORY_CHECKER_RESULTS_SUCCEEDED:
      return {...state, isFetching: false, storyCheckerResults: payload};
    case FETCH_STORY_CHECKER_RESULTS_FAILED:
      return {...state, isFetching: false, storyCheckerResults: []};

    case FETCH_STORY_CHECKER_DETAIL:
      return {
        ...state,
        isFetching: true,
        storyCheckerDetail: {profileId: payload.profileId, url: payload.url},
        modalStage: MODAL_STAGES.results
      };
    case FETCH_STORY_CHECKER_DETAIL_SUCCEEDED:
      return {
        ...state,
        isFetching: false,
        storyCheckerDetail: {...state.storyCheckerDetail, ...payload},
        modalStage: MODAL_STAGES.resultDetail
      };
    case FETCH_STORY_CHECKER_DETAIL_FAILED:
      return {...state, isFetching: false, storyCheckerDetail: {}};

    case FETCH_SOURCE_CHECKER_SIMILARS: {
      const { mediaOutlet } = payload;
      return {...state, modalStage: MODAL_STAGES.results, fetchingSimilarFor: mediaOutlet};
    }
    case FETCH_SOURCE_CHECKER_SIMILARS_SUCCEEDED: {
      const { mediaOutlet, similarSources } = payload;
      state.sourceCheckerSimilars.set(mediaOutlet, similarSources);
      const showSourceCheckerSimilars = Object.assign({}, state.showSourceCheckerSimilars, {[mediaOutlet]: true});
      return {...state, showSourceCheckerSimilars, fetchingSimilarFor: null};
    }
    case FETCH_SOURCE_CHECKER_SIMILARS_FAILED:
      return {...state, fetchingSimilarFor: null};

    case SET_CHECK_BY:
      return {...state,
        selectedCheckByOption: payload,
        sourcesOrStoriesToCheck: '',
        selectedSourceOrStoryType: undefined
      };
    case SET_SOURCE_TYPE: {
      // LexisNexis source is only valid for content, not for URLs
      const selectedSource = payload === 'urls' && state.selectedSource === 'lexis_nexis'
        ? null
        : state.selectedSource;

      return {
        ...state,
        selectedSourceOrStoryType: payload,
        sourcesOrStoriesToCheck: '',
        selectedSource
      };
    }
    case SET_IS_MODAL_FORM_STEP:
      return {...state, modalStage: payload};
    case TOGGLE_MODAL:
      return {...state, isModalOpen: payload};
    case TOGGLE_FILTER: {
      const filters = Object.assign({}, state.filters, {[payload]: !state.filters[payload]});
      return {...state, filters};
    }
    case HIDE_SIMILAR_SOURCES: {
      const showSourceCheckerSimilars = Object.assign({}, state.showSourceCheckerSimilars, {[payload]: false});
      return {...state, showSourceCheckerSimilars};
    }
    case STORY_PROFILE_SELECTION: {
      const selectedProfiles  = payload.value;
      let includedAll = state.includeAll;
      if(payload.value.length === 0){
        includedAll = false;
      }
      else if (selectedProfiles.length === payload.profiles.length){
        includedAll = true;
      }
      else {
        includedAll = false;
      }
      return { ...state, selectedProfiles, includeAll : includedAll };
    }
    case STORY_SOURCE_SELECTION: {
      return { ...state, selectedSource: payload.source };
    }
    case EDIT_TITLE: {
      return { ...state, title: payload };
    }
    case TOGGLE_INCLUDE_ALL: {
      const selectedProfiles  = (payload.event.target.checked) ? payload.profiles : [];
      return { ...state, selectedProfiles, includeAll: payload.event.target.checked };
    }
    default: return state;
  }
};

// Action Creators
const editSourcesOrStoriesList = (event) => {
  return { type: EDIT_SOURCES_OR_STORIES_LIST, payload: event.target.value };
};

const handleTitleChanged = (event) => {
  return { type: EDIT_TITLE, payload: event.target.value };
};

const handleIncludeAll = (payload) => {
  return { type: TOGGLE_INCLUDE_ALL, payload };
};

const setCheckBy = (event) => {
  return { type: SET_CHECK_BY, payload: event.target.value };
};

const setSourceType = (payload) => {
  return { type: SET_SOURCE_TYPE, payload };
};

const setModalVisibility = (payload) => {
  return { type: TOGGLE_MODAL, payload};
};

const setModalStage = (payload) => {
  return { type: SET_IS_MODAL_FORM_STEP, payload};
};

const clearModalForm = () => {
  return { type: CLEAR_MODAL_FORM };
};

const fetchSourceCheckerResults = (payload) => {
  return { type: FETCH_SOURCE_CHECKER_RESULTS, campaignId: payload };
};

const fetchSourceCheckerResultsFailed = () => {
  return { type: FETCH_SOURCE_CHECKER_RESULTS_FAILED };
};

const fetchSourceCheckerResultsSucceeded = (payload) => {
  return { type: FETCH_SOURCE_CHECKER_RESULTS_SUCCEEDED, payload };
};

const fetchStoryCheckerResults = (payload) => {
  return { type: FETCH_STORY_CHECKER_RESULTS, campaignId: payload };
};

const fetchStoryCheckerResultsFailed = () => {
  return { type: FETCH_STORY_CHECKER_RESULTS_FAILED };
};

const fetchStoryCheckerResultsSucceeded = (payload) => {
  return { type: FETCH_STORY_CHECKER_RESULTS_SUCCEEDED, payload };
};

const fetchStoryCheckerDetail = (detailRequest) => {
  const { profileId, title, body, sourceType, url } = detailRequest;
  return { type: FETCH_STORY_CHECKER_DETAIL, payload: { profileId, title, body, sourceType, url }};
};

const fetchStoryCheckerDetailFailed = () => {
  return { type: FETCH_STORY_CHECKER_DETAIL_FAILED };
};

const fetchStoryCheckerDetailSucceeded = (payload) => {
  return { type: FETCH_STORY_CHECKER_DETAIL_SUCCEEDED, payload };
};

// only applies for source checker media otlets
const fetchSourceCheckerSimilars = (payload) => {
  return { type: FETCH_SOURCE_CHECKER_SIMILARS, payload };
};

const fetchSourceCheckerSimilarsFailed = () => {
  return { type: FETCH_SOURCE_CHECKER_SIMILARS_FAILED };
};

const fetchSourceCheckerSimilarsSucceeded = (payload) => {
  return { type: FETCH_SOURCE_CHECKER_SIMILARS_SUCCEEDED, payload };
};

const handleFilterChange = (payload) => {
  return { type: TOGGLE_FILTER, payload };
};

const handleHideSimilarSources = (payload) => {
  return { type: HIDE_SIMILAR_SOURCES, payload };
};

const handleProfilesChange = (payload) => {
  return { type: STORY_PROFILE_SELECTION, payload };
};

const handleSourceSelection = (payload) => {
  return { type: STORY_SOURCE_SELECTION, payload };
};

export default reducer;
export {
  // Actions
  CLEAR_MODAL_FORM,
  EDIT_SOURCES_OR_STORIES_LIST,
  FETCH_SOURCE_CHECKER_RESULTS,
  FETCH_SOURCE_CHECKER_RESULTS_FAILED,
  FETCH_SOURCE_CHECKER_RESULTS_SUCCEEDED,
  FETCH_STORY_CHECKER_RESULTS,
  FETCH_STORY_CHECKER_RESULTS_FAILED,
  FETCH_STORY_CHECKER_RESULTS_SUCCEEDED,
  FETCH_STORY_CHECKER_DETAIL,
  FETCH_STORY_CHECKER_DETAIL_FAILED,
  FETCH_STORY_CHECKER_DETAIL_SUCCEEDED,
  FETCH_SOURCE_CHECKER_SIMILARS,
  FETCH_SOURCE_CHECKER_SIMILARS_FAILED,
  FETCH_SOURCE_CHECKER_SIMILARS_SUCCEEDED,
  SET_CHECK_BY,
  SET_SOURCE_TYPE,
  SET_IS_MODAL_FORM_STEP,
  TOGGLE_MODAL,
  TOGGLE_FILTER,
  HIDE_SIMILAR_SOURCES,
  STORY_PROFILE_SELECTION,
  EDIT_TITLE,
  TOGGLE_INCLUDE_ALL,
  // Action Creators
  clearModalForm,
  editSourcesOrStoriesList,
  fetchSourceCheckerResults,
  fetchSourceCheckerResultsFailed,
  fetchSourceCheckerResultsSucceeded,
  fetchStoryCheckerResults,
  fetchStoryCheckerResultsFailed,
  fetchStoryCheckerResultsSucceeded,
  fetchStoryCheckerDetail,
  fetchStoryCheckerDetailFailed,
  fetchStoryCheckerDetailSucceeded,
  fetchSourceCheckerSimilars,
  fetchSourceCheckerSimilarsFailed,
  fetchSourceCheckerSimilarsSucceeded,
  setCheckBy,
  setModalVisibility,
  setSourceType,
  setModalStage,
  handleFilterChange,
  handleHideSimilarSources,
  handleProfilesChange,
  handleSourceSelection,
  handleTitleChanged,
  handleIncludeAll,
  // Constants
  MODAL_STAGES,
  SOURCE_OPTIONS_URLS,
  SOURCE_OPTIONS_CONTENT
};
